import { render, staticRenderFns } from "./branded-fare-upsell-table.vue?vue&type=template&id=49ce8f07"
import script from "./branded-fare-upsell-table.vue?vue&type=script&lang=js"
export * from "./branded-fare-upsell-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports